<template src="./Edit.html">
</template>

<script>
    // import { showAlert } from "@/utils/helpers";
    import { VueEditor } from "vue2-editor";

    export default {
        components: { VueEditor },

        props: {
            itemId: {
                type: Number,
                required: true,
            },
        },

        created() {
            this.$store
                .dispatch("instructions/getForEdit", this.itemId)
                .then((res) => {
                    this.vm = res;
                }).catch(() => { });


        },
        computed: {


        },
        data() {
            return {
                vm: {
                    title: null,
                    tipContent: "",
                },

            };
        },
        methods: {
            confirm() {
                this.$store
                    .dispatch("instructions/edit", { id: this.itemId, payload: this.vm })
                    .then(() => {
                        this.back();
                    })
                    .catch(() => { });
            },

            back() {

                this.$emit("back");
            },
        },
    };
</script>